import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';


const firebaseConfig = {
    apiKey: "AIzaSyBmbS-w118rjZdL0xUuXcwgk7-1hGpD5pA",
    authDomain: "savora-efd02.firebaseapp.com",
    projectId: "savora-efd02",
    storageBucket: "savora-efd02.appspot.com",
    messagingSenderId: "1024257647685",
    appId: "1:1024257647685:web:71a8c66ad192d46733ef2c",
    measurementId: "G-3D47CLDRBN"
  };

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);